<script>
//--------------------------------------------------
// imported classes
//--------------------------------------------------
// import Vue from 'vue'
// import { Dialog, Toast } from 'vant'
import AbastractScene from '@/tbs/core/AbstractScene.vue'

//--------------------------------------------------
// global registration
//--------------------------------------------------
// Vue.use(Dialog, Toast)

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    extends: AbastractScene,
    data() {
		return {
            rootData: {},
            locale: {}
		}
	},
}
</script>

<template>
    <!-- component -->
    <div class="scene">
        <div class="header">
            <p>{{ locale['sport-type'] }}</p>
            <p>{{ rootData.label }}</p>
        </div>
        <div>
            <a href="/#/match-detail-demo/tab1">Tab 1</a>
            <a href="/#/match-detail-demo/tab2">Tab 2</a>
        </div>
        <!-- router view as scene view -->
        <router-view
            class="scene-view"
            :key="Date.now()" 
            ref="sceneView" 
            @custom-event="onCustomEvent" 
        />
    </div>
</template>